import { useState, useEffect } from 'react';
import { getWarehouseById } from '../services/warehouseService';
import { fetchSupplierProductBySupplierID } from '../services/supplierProductService';
import { getSuppliers } from '../../../../store/actions/dashboardAction'
import API from "../../../../network/dashboardAPI";

export const useWarehouse = (id) => {
  const editMode = !!id;
  const [warehouseName, setWarehouseName] = useState('');
  const [warehouseSupplier, setWarehouseSupplier] = useState(0);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [warehouseAddress, setWarehouseAddress] = useState('');
  const [warehouseComment, setWarehouseComment] = useState('');
  const [IsDSWarehouse, setIsDSWarehouse] = useState(false);
  const [IsMainWarehouse, setIsMainWarehouse] = useState(false);
  const [IsDefaultWarehouse, setIsDefaultWarehouse] = useState(false);
  const [coordinate, setCoordinate] = useState({
    latitude: 11.5564,
    longitude: 104.9282,
  });
  const [formErrors, setFormErrors] = useState({
    warehouseName: '',
    warehouseSupplier: '',
    warehouseAddress: ''
  });
  const [locationSections, setLocationSections] = useState([{ element_id: 1, id: null, name: 'Default' }]);
  const [errors, setErrors] = useState({});
  const [supplierProducts, setSupplierProducts] = useState([]);

  // Load warehouse data when in edit mode
  useEffect(() => {
    if (editMode) {
      getWarehouseById(id)
        .then((res) => {
          if (res.data) {
            setWarehouseName(res.data.name);
            API.getSuppliers()
              .then((response) => response.json())
              .then(response => {
                setWarehouseSupplier(response.data.find((supplier) => supplier.store_user_id == res.data.supplier_id));
              })
            setWarehouseAddress(res.data.address);
            setWarehouseComment(res.data.comment);
            setIsDSWarehouse(res.data.is_ds_warehouse === true ? true : false);
            setIsMainWarehouse(res.data.is_main_warehouse === true ? true : false);
            setIsDefaultWarehouse(res.data.is_default === true ? true : false);
            setCoordinate({
              latitude: res.data.lat ?? 11.5564,
              longitude: res.data.lng ?? 104.9282,
            });
            if (res.data.locations && res.data.locations.length > 0) {
              let section_id = 1;
              const formattedLocations = res.data.locations.map((data) => {
                const elementId = section_id++;
                return {
                  element_id: elementId,
                  id: data.id,
                  // supplier_product_id: data.supplier_product_id || 0,
                  // quantity: data.quantity || 0,
                  name: data.name,
                  is_default: data.is_default || false,
                };
              });
              
              setLocationSections(formattedLocations);
            } else {
              const newLocation = { element_id: 1, id: null, name: 'Default' };
              setLocationSections([newLocation]);
            }
          }
        })
        .catch((error) => console.error('Error fetching warehouse:', error));
    } else {
      const newLocation = { element_id: 1, id: null, name: 'Default' };
      setLocationSections([newLocation]);
    }
  }, [id, editMode]);
  
  // Load products when in edit mode
  useEffect(() => {
    if (editMode && warehouseSupplier && warehouseSupplier !== 0) {
      setLoadingProducts(true);
      fetchSupplierProductBySupplierID(warehouseSupplier)
        .then((res) => {
          if (res.data) {
            setSupplierProducts(res.data);
          }
        })
        .catch((error) => {
          console.error('Error fetching products:', error);
          setSupplierProducts([]);
        })
        .finally(() => {
          setLoadingProducts(false);
        });
    }
  }, [editMode, warehouseSupplier]);

  return {
    editMode,
    warehouseName,
    setWarehouseName,
    warehouseSupplier,
    setWarehouseSupplier,
    loadingProducts,
    setLoadingProducts,
    warehouseAddress,
    setWarehouseAddress,
    warehouseComment,
    setWarehouseComment,
    IsDSWarehouse,
    setIsDSWarehouse,
    IsMainWarehouse,
    setIsMainWarehouse,
    IsDefaultWarehouse,
    setIsDefaultWarehouse,
    coordinate,
    setCoordinate,
    formErrors,
    setFormErrors,
    locationSections,
    setLocationSections,
    errors,
    setErrors,
    supplierProducts,
    setSupplierProducts,
  };
};